import React, { useState, useCallback } from 'react';
import { Card, Input, Button, Space, message, Tag } from 'antd';
import { AudioOutlined } from '@ant-design/icons';
import VoiceInput from './VoiceInput';
import { riddles, Riddle } from '../data/riddles';
import { checkAnswer } from '../services/api';

const getRandomRiddle = (currentId?: string): Riddle => {
  const availableRiddles = currentId 
    ? riddles.filter(r => r.id !== currentId)
    : riddles;
  const randomIndex = Math.floor(Math.random() * availableRiddles.length);
  return availableRiddles[randomIndex];
};

const RiddlePage: React.FC = () => {
  const [answer, setAnswer] = useState('');
  const [score, setScore] = useState<number | null>(null);
  const [currentRiddle, setCurrentRiddle] = useState<Riddle>(getRandomRiddle());
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleVoiceResult = (text: string) => {
    setAnswer(text);
  };

  const handleSubmit = async () => {
    if (!answer.trim()) {
      message.warning('请输入答案');
      return;
    }

    setIsSubmitting(true);
    try {
      const score = await checkAnswer(answer, currentRiddle.id);
      setScore(score);
      message.success(`提交成功！得分：${score}`);
    } catch (error) {
      message.error('提交失败，请重试');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChangeRiddle = useCallback(() => {
    setCurrentRiddle(getRandomRiddle(currentRiddle.id));
    setAnswer('');
    setScore(null);
  }, [currentRiddle.id]);

  return (
    <div style={{ maxWidth: 800, margin: '20px auto', padding: '0 20px' }}>
      <Card 
        title="猜谜语" 
        style={{ marginBottom: 20 }}
        extra={
          <Button type="primary" onClick={handleChangeRiddle}>
            换一题
          </Button>
        }
      >
        <div style={{ marginBottom: 10 }}>
          <Tag color="blue">{currentRiddle.category}</Tag>
        </div>
        <p style={{ fontSize: 18, marginBottom: 20 }}>{currentRiddle.question}</p>
        {currentRiddle.hint && (
          <p style={{ color: '#666', fontSize: 14 }}>提示：{currentRiddle.hint}</p>
        )}
      </Card>

      <Card title="你的答案">
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Input 
              style={{ flex: 1 }}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              placeholder="请输入答案或使用语音输入"
            />
            <VoiceInput onResult={handleVoiceResult} />
          </div>
          
          <Button 
            type="primary" 
            onClick={handleSubmit}
            loading={isSubmitting}
            style={{ width: '100%', height: 40 }}
          >
            提交答案
          </Button>

          {score !== null && (
            <div style={{ marginTop: 20 }}>
              <h3>得分：{score}</h3>
              {score >= 90 && <p style={{ color: 'green' }}>恭喜你答对了！</p>}
              {score >= 60 && score < 90 && <p style={{ color: 'orange' }}>非常接近了！</p>}
              {score >= 30 && score < 60 && <p style={{ color: 'blue' }}>有点接近了！</p>}
              {score < 30 && <p style={{ color: 'red' }}>再想想看~</p>}
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default RiddlePage; 